/* eslint-disable react/no-children-prop */
import { Box, Flex, Spinner } from "@chakra-ui/react";
import { FixedSizeList, ListChildComponentProps } from "react-window";
import L from "leaflet";

import { TextGray } from "components/Atomos/Texts/TextGray";
import { ComponentType, useEffect, useRef } from "react";

// eslint-disable-next-line @typescript-eslint/no-explicit-any
type Props<T = any> = {
  shouldOpen: boolean;
  isLoading: boolean;
  items: T[];
  render: ComponentType<ListChildComponentProps<T>>;
  isDirty: boolean;
};

export const ResultArea = ({
  isLoading,
  shouldOpen,
  render,
  items,
  isDirty
}: Props) => {
  const qtdItems = items.length;
  const minW = 360;
  const containerRef = useRef<HTMLDivElement>(null);

  // sem isso o wheel sobre a listagem chega ao mapa e altera o zoom
  useEffect(() => {
    if (containerRef.current) {
      L.DomEvent.disableScrollPropagation(containerRef.current);
    }
  }, []);

  return (
    <Box
      ref={containerRef}
      position="absolute"
      top="2.6rem"
      mt="1"
      bgColor="white"
      _dark={{ bgColor: "gray.900" }}
      display={shouldOpen ? "block" : "none"}
      transition="ease-out"
      minW={minW}
      borderRadius="md"
      boxShadow="md"
      overflow="hidden"
      tabIndex={1}
    >
      {isLoading ? (
        <Flex minW={minW} py="2" justifyContent="center" align="center">
          <Spinner size="sm" color="gray.500" />
          <TextGray ml="2">Carregando</TextGray>
        </Flex>
      ) : qtdItems === 0 ? (
        <Flex minW={minW} py="2" justifyContent="center" align="center">
          <TextGray>
            {isDirty ? "Sem resultados" : "Nenhum filtro aplicado"}
          </TextGray>
        </Flex>
      ) : (
        <>
          <FixedSizeList
            height={(qtdItems > 6 ? 6 : qtdItems) * 50}
            itemCount={qtdItems}
            itemData={items}
            itemSize={50}
            width={minW}
          >
            {render}
          </FixedSizeList>
          <Box pr="2" py="0.5" fontSize="xx-small" textAlign="right">
            <TextGray>{qtdItems} resultados</TextGray>
          </Box>
        </>
      )}
    </Box>
  );
};
